import Swal from 'sweetalert2';

// Configuración por defecto para SweetAlert2
const defaultConfig = {
  confirmButtonText: 'Aceptar',
  cancelButtonText: 'Cancelar'
};

// Alerta de éxito
export const showSuccess = (message, title = '¡Éxito!') => {
  return Swal.fire({
    ...defaultConfig,
    icon: 'success',
    title: title,
    text: message,
    confirmButtonText: 'Aceptar'
  });
};

// Alerta de error
export const showError = (message, title = 'Error') => {
  return Swal.fire({
    ...defaultConfig,
    icon: 'error',
    title: title,
    text: message,
    confirmButtonText: 'Aceptar'
  });
};

// Alerta de información
export const showInfo = (message, title = 'Información') => {
  return Swal.fire({
    ...defaultConfig,
    icon: 'info',
    title: title,
    text: message,
    confirmButtonText: 'Aceptar'
  });
};

// Alerta de advertencia
export const showWarning = (message, title = 'Advertencia') => {
  return Swal.fire({
    ...defaultConfig,
    icon: 'warning',
    title: title,
    text: message,
    confirmButtonText: 'Aceptar'
  });
};

// Confirmación con botones Sí/No
export const showConfirm = (message, title = '¿Estás seguro?') => {
  return Swal.fire({
    ...defaultConfig,
    icon: 'question',
    title: title,
    text: message,
    showCancelButton: true,
    confirmButtonText: 'Sí',
    cancelButtonText: 'No'
  });
};

// Confirmación para eliminar
export const showDeleteConfirm = (message = '¿Estás seguro de que quieres eliminar este elemento?', options = {}) => {
  return Swal.fire({
    ...defaultConfig,
    icon: 'warning',
    title: '¿Eliminar?',
    text: message,
    showCancelButton: true,
    confirmButtonText: 'Sí, eliminar',
    cancelButtonText: 'Cancelar',
    ...options
  });
};

// Toast notification (pequeña notificación)
export const showToast = (message, icon = 'success') => {
  return Swal.fire({
    toast: true,
    position: 'top-end',
    icon: icon,
    title: message,
    showConfirmButton: false,
    timer: 2500,
    timerProgressBar: true,
    background: getComputedStyle(document.documentElement).getPropertyValue('--brand-primary').trim() || '#1a1a1a',
    color: '#ffffff',
    iconColor: '#ffffff',
    customClass: {
      popup: 'colored-toast'
    },
    didOpen: (toast) => {
      toast.addEventListener('mouseenter', Swal.stopTimer);
      toast.addEventListener('mouseleave', Swal.resumeTimer);
    }
  });
};

// Toast de carrito agregado (específico para agregar al carrito)
export const showCartToast = (productName = '') => {
  const message = productName 
    ? `${productName} agregado al carrito` 
    : '¡Producto agregado al carrito!';
  
  return Swal.fire({
    toast: true,
    position: 'top-end',
    icon: 'success',
    title: message,
    showConfirmButton: false,
    timer: 2500,
    timerProgressBar: true,
    background: getComputedStyle(document.documentElement).getPropertyValue('--brand-primary').trim() || '#1a1a1a',
    color: '#ffffff',
    iconColor: '#ffffff',
    customClass: {
      popup: 'colored-toast'
    },
    didOpen: (toast) => {
      toast.addEventListener('mouseenter', Swal.stopTimer);
      toast.addEventListener('mouseleave', Swal.resumeTimer);
    }
  });
};
